import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select
} from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { bookingApi } from "functions/apis";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export function EditPortBookingConfiguration(props) {
  const classes = useStyles();

  const editPortBookingConfigurationSignal = React.useRef(
    new AbortController()
  );
  const { id } = useParams();

  const [port, setPort] = useState(null);
  const [payload, setPayload] = useState(null);
  const [timeZones, setTimeZones] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (
      token["booking.time_zones.read"] === "allowed" ||
      token.is_admin === "True"
    )
      bookingApi
        .get("/TimeZones", {
          signal: editPortBookingConfigurationSignal.current.signal
        })
        .then(data => setTimeZones(data))
        .catch(error => console.log(error));

    return () => editPortBookingConfigurationSignal.current.abort();
  }, []);

  useEffect(() => {
    if (token["booking.ports.read"] === "allowed" || token.is_admin === "True")
      bookingApi
        .get("/Ports/" + id, {
          signal: editPortBookingConfigurationSignal.current.signal
        })
        .then(data => {
          setPort(data);
          setPayload({
            scheduleTimeZone: data.scheduleTimeZone,
            sccCode: data.sccCode,
            btcCode: data.btcCode
          });
        })
        .catch(error => console.log(error));
  }, [id]);

  const handleScheduleTimeZoneChanged = e =>
    setPayload({
      ...payload,
      scheduleTimeZone: e.target.value === "" ? null : e.target.value
    });

  const handleSCCCodeChanged = e =>
    setPayload({
      ...payload,
      sccCode: e.target.value === "" ? null : e.target.value
    });

  const handleBTCCodeChanged = e =>
    setPayload({
      ...payload,
      btcCode: e.target.value === "" ? null : e.target.value
    });

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    bookingApi
      .put("/Ports/" + id, payload, {
        signal: editPortBookingConfigurationSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Port/Detail/" + id} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              EDIT BOOKING CONFIGURATION
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            {payload !== null && (
              <form onSubmit={handleSubmit}>
                <GridContainer>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: port?.code ?? "",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: port?.name ?? "",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    {timeZones.length > 0 ? (
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="selScheduleTimeZone"
                          className={classes.selectLabel}
                        >
                          SCHEDULE TIME ZONE
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu
                          }}
                          classes={{
                            select: classes.select
                          }}
                          value={payload.scheduleTimeZone ?? ""}
                          onChange={handleScheduleTimeZoneChanged}
                        >
                          {timeZones.map(record => {
                            return (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={record.id}
                                key={record.id}
                              >
                                <p>{record.displayName}</p>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    ) : (
                      <CustomInput
                        labelText="Schedule Time Zone"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          onChange: handleScheduleTimeZoneChanged,
                          value: payload.scheduleTimeZone ?? ""
                        }}
                      />
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <CustomInput
                      labelText="SCC Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: handleSCCCodeChanged,
                        value: payload.sccCode ?? ""
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <CustomInput
                      labelText="BTC Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: handleBTCCodeChanged,
                        value: payload.btcCode ?? ""
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={12}>
                    <Button
                      disabled={disabled}
                      color="rose"
                      type="submit"
                      value="Submit"
                    >
                      Submit
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

EditPortBookingConfiguration.propTypes = {
  history: PropTypes.object
};
